window.addEventListener('DOMContentLoaded', () => {
  const $menuButton = document.querySelector('.cmp-header__menu-button');
  const $menuNav = document.querySelector('.cmp-header__menu-nav');
  const $closeButton = document.querySelector(
    '.cmp-header__menu-nav .cmp-header__menu-close-button'
  );
  const $primaryNavLinks = document.querySelectorAll(
    '.cmp-header__menu-nav-primary .cmp-navigation__item-link'
  );

  const togglemenuNav = () => {
    $menuButton?.classList.toggle('cmp-header__menu-button--active');
    $menuNav?.classList.toggle('cmp-header__menu-nav--visible');
  };

  $menuButton?.addEventListener('click', () => {
    togglemenuNav();
  });

  $closeButton?.addEventListener('click', () => {
    togglemenuNav();
  });

  // Mega menu primary navigation
  Array.from($primaryNavLinks).forEach(($navLink) => {
    $navLink.addEventListener('click', (e: any) => {
      // User has pressed Ctrl/Cmd when clicking - return so link opens in new tab
      if (e.ctrlKey || e.metaKey) {
        return true;
      }

      const $parent = $navLink.closest('.cmp-navigation__item');

      if ($parent?.classList.contains('cmp-navigation__item--visible')) {
        $parent?.classList.remove('cmp-navigation__item--visible');
        return;
      }

      const levelClass = $parent
        ? Array.from($parent.classList.values()).find((x) =>
            x.includes('cmp-navigation__item--level-')
          )
        : '';

      // Remove visible class from other items in same level
      Array.from($primaryNavLinks).forEach(($navLink) => {
        const $parent = $navLink.closest('.cmp-navigation__item');
        if ($parent && levelClass && $parent.classList.contains(levelClass)) {
          $parent.classList.remove('cmp-navigation__item--visible');
        }
      });

      // Show subnav
      $parent?.classList.add('cmp-navigation__item--visible');

      // Follow link if there is no subnav
      if ($parent?.querySelector('.cmp-navigation__group')) {
        e.preventDefault();
      }
    });
  });
});
